import styled from 'react-emotion'

const Table = styled('table')({
    width: '100%',
    borderSpacing: '0 5px !important'
})

export default Table


// WEBPACK FOOTER //
// ./src/components/TableComponent.jsx